import React, { useEffect } from 'react';
import { CreditCard, Calendar, Clock, RefreshCw, FileText, Calculator } from 'lucide-react';

const PaymentTerms = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const terms = [
    {
      icon: <CreditCard className="h-6 w-6" />,
      title: 'Accepted Payment Methods',
      description: 'We accept credit/debit cards via Stripe, bank transfers, and cash payments.'
    },
    {
      icon: <FileText className="h-6 w-6" />,
      title: 'Invoices',
      description: 'All payments will be processed electronically, and an invoice will be sent via email.'
    },
    {
      icon: <Calendar className="h-6 w-6" />,
      title: 'Payment Schedule',
      description: 'For standard services, payment is due upon completion unless otherwise agreed. For larger projects (e.g., pool construction), a deposit may be required.'
    },
    {
      icon: <Clock className="h-6 w-6" />,
      title: 'Late Payments',
      description: 'Unpaid invoices beyond 7 days may incur late fees.'
    },
    {
      icon: <RefreshCw className="h-6 w-6" />,
      title: 'Refund Policy',
      description: 'Payments for completed services are non-refundable, but we ensure customer satisfaction through quality service.'
    },
    {
      icon: <Calculator className="h-6 w-6" />,
      title: 'Quotes & Pricing',
      description: 'All quotes are valid for 14 days and may be adjusted based on project requirements.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment Terms</h1>
          <p className="text-lg text-gray-600">
            Clear and transparent payment policies for our services
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {terms.map((term, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
            >
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="p-2 bg-cyan-50 rounded-lg text-cyan-600">
                    {term.icon}
                  </div>
                  <h3 className="ml-4 text-xl font-semibold text-gray-900">
                    {term.title}
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  {term.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-xl shadow-md p-6">
          <div className="flex items-center justify-center space-x-4 mb-4">
            <img src="/visa-logo.png" alt="Visa" className="h-8" />
            <img src="/mastercard-logo.png" alt="Mastercard" className="h-8" />
          </div>
          <p className="text-center text-gray-600">
            Secure payments processed by Stripe
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentTerms; 